import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api, apiErr } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const check = useCallback(async () => {
    if (window.location.hash?.includes("session_id=")) { return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    return data.user;
  }, []);
  const register = useCallback(async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data.user);
    return data.user;
  }, []);
  const loginMobile = useCallback(async (accessToken) => {
    const { data } = await api.post("/auth/mobile/verify", { access_token: accessToken });
    setUser(data.user);
    return data.user;
  }, []);
  const signupSendOtp = useCallback(async (payload) => (await api.post("/auth/signup/send-otp", payload)).data, []);
  const signupVerify = useCallback(async (email, otp) => {
    const { data } = await api.post("/auth/signup/verify-otp", { email, otp });
    setUser(data.user);
    return data.user;
  }, []);
  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("logout request failed", e); }
    setUser(false);
  }, []);
  const refresh = check;

  const value = useMemo(() => ({ user, setUser, login, register, loginMobile, signupSendOtp, signupVerify, logout, refresh, apiErr }), [user, login, register, loginMobile, signupSendOtp, signupVerify, logout, refresh]);

  return (
    <AuthCtx.Provider value={value}>
      {children}
    </AuthCtx.Provider>
  );
}
